import { PageHeader, Tag, Tooltip } from "antd";
import React, { Component } from "react";
import axios from "axios";
import { ButtonItem, SegmentedItem, TableItem } from "../../../Components/Items";
import { connect } from "react-redux";
import moment from "moment";
import "moment/locale/es";
import { EditOutlined} from "@ant-design/icons";

moment.locale("es");

class Presupuestos extends Component {
  state = {
    todasPresupuestos: [],
    loading: false,
    valor: 1,
  };
  componentDidMount() {
    this.consultarPresupuestos(this.state.valor);
  }

  consultarPresupuestos(valor) {
    this.setState({ loading: true });
    axios
      .post(
        "presupuestos/selectTodasPresupuestos",
        { empresaId: this.props.empresaId, valor: valor },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.status === 404) {
          this.setState({ todasPresupuestos: [] });
        } else {
          this.setState({
            todasPresupuestos: res.data
          });
        }
      });
  }
  verPresupuesto(id) {
    this.props.history.push("/panel/verPresupuesto", { id });
  }
  agregarPresupuesto() {
    this.props.history.push("/panel/agregarPresupuesto");
  }
  editarPresupuesto(id) {
    this.props.history.push("/panel/editarPresupuesto", { id });
  }
  render() {
    const columns = [
      {
        title: "Nombre",
        dataIndex: "nombre",
        key: "nombre",
        sorter: (a, b) => {
          if (a.nombre < b.nombre) {
            return -1;
          }
          if (a.nombre > b.nombre) {
            return 1;
          }
          return 0;
        },
        buscar: "nombre",
        ellipsis: true,
      },
      {
        title: "Descripción",
        dataIndex: "descripcion",
        key: "descripcion",
        sorter: (a, b) => {
          if (a.descripcion < b.descripcion) {
            return -1;
          }
          if (a.descripcion > b.descripcion) {
            return 1;
          }
          return 0;
        },
        buscar: "descripcion",
        ellipsis: true,
      },
      {
        title: "Proyecto",
        dataIndex: "proyecto",
        key: "proyecto",
        sorter: (a, b) => {
          if (a.proyecto < b.proyecto) {
            return -1;
          }
          if (a.proyecto > b.proyecto) {
            return 1;
          }
          return 0;
        },
        buscar: "proyecto",
        ellipsis: true,
      },
      {
        title: "Fecha Inicial",
        dataIndex: "fechaInicial",
        key: "fechaInicial",
        sorter: (a, b) => {
          if (moment(a.fechaInicial) < moment(b.fechaInicial)) {
            return -1;
          }
          if (moment(a.fechaInicial) > moment(b.fechaInicial)) {
            return 1;
          }
          return 0;
        },
        buscar: "fechaInicial",
        render: (value) => moment(value).locale('es').format('L'),
        ellipsis: true,
      },
      {
        title: "Fecha Final",
        dataIndex: "fechaFinal",
        key: "fechaFinal",
        sorter: (a, b) => {
          if (moment(a.fechaFinal) < moment(b.fechaFinal)) {
            return -1;
          }
          if (moment(a.fechaFinal) > moment(b.fechaFinal)) {
            return 1;
          }
          return 0;
        },
        buscar: "fechaFinal",
        render: (value) => value ? moment(value).locale('es').format('L') : 'No tiene',
        ellipsis: true,
      },
      {
        title: "Estado",
        dataIndex: "estado",
        key: "estado",
        render: (value) => {
          if (value === 0) {
            return <Tag color="red" className="square-tag">Cancelada</Tag>;
          }
          if (value === 1) {
            return <Tag color="blue" className="square-tag">Vigente</Tag>;
          }
        },
        width: "13%",
      },
      {
        title: "Acción",
        dataIndex: "accion",
        key: "accion",
        align: "center",
        width: "15%",
        onHeaderCell: () => ({
          style: { textAlign: 'center', padding: '4px' }
        }),
        onCell: () => ({
          className: "acciones-sin-hover",
          style: { textAlign: 'center', padding: '4px' }
        }),
        render: (value) => {
          let buttons = [];

          // Botón Editar (solo si el estado es vigente, es decir, estado !== 0)
          if (value.estado !== 0) {
            buttons.push(
              <Tooltip title="Editar Presupuesto" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                <ButtonItem
                  key={`editar-${value._id}`}
                  type="default"
                  size="small"
                  cyan
                  icon={<EditOutlined />}
                  onClick={() => this.editarPresupuesto(value._id)}
                >
                </ButtonItem>
              </Tooltip>
            );
          }

          return <div className="acciones-container">{buttons}</div>;
        },
      },
    ];
    return (
      <>
        <PageHeader
          title="Presupuestos"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            <>
            {window.innerWidth > 1000 &&
            <SegmentedItem
                options={[{label: 'Vigente', value: 1}, {label: 'Cancelada', value: 2}, {label: 'Todos', value: 3}]}
                onChange={(value) => {
                  this.consultarPresupuestos(value)
                  this.setState({ valor: value })
                }}
                value={this.state.valor}
              />
          }
            <ButtonItem
              type="primary"
              key="agregarPresupuesto"
              olivo
              onClick={this.agregarPresupuesto.bind(this)}
               className="botonAgregar"
            >
              Agregar Presupuesto
            </ButtonItem>
            </>
          }
        />
        <TableItem
          size="small"
          onRow={(record, rowIndex) => {
            return {
              onDoubleClick: (event) => {
                this.verPresupuesto(record._id)
              },
            };
          }}
          loading={this.state.loading}
          dataSource={this.state.todasPresupuestos}
          columns={columns}
          pagination={false}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(Presupuestos);
